export default "__VITE_ASSET__08ff2f05__"